module.exports = __webpack_public_path__ + "img/bftw-2022-comunidade.1733427b.png";